import { render, staticRenderFns } from "./channelPopupRussia.vue?vue&type=template&id=5cc9509e&scoped=true"
import script from "./channelPopupRussia.vue?vue&type=script&lang=js"
export * from "./channelPopupRussia.vue?vue&type=script&lang=js"
import style0 from "./channelPopupRussia.vue?vue&type=style&index=0&id=5cc9509e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cc9509e",
  null
  
)

export default component.exports